import { render, staticRenderFns } from "./TagsList.vue?vue&type=template&id=e16a7bc2&scoped=true"
import script from "./TagsList.vue?vue&type=script&lang=ts"
export * from "./TagsList.vue?vue&type=script&lang=ts"
import style0 from "./TagsList.vue?vue&type=style&index=0&id=e16a7bc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e16a7bc2",
  null
  
)

export default component.exports